export class SCROLLABLE_NAV {
  constructor(domquery){
    this.containers = document.querySelectorAll(domquery);
    this.containers.forEach( (v,i) => this.init(v) );
    
  }
  init (container=false) {
    if( !container ) return false;
    const container_width = container.offsetWidth;
    const nav_width = container.querySelector('.local-nav-list').offsetWidth;
    const triggerHTML = `<div class="trigger-first"></div><div class="trigger-last"></div>`;
    if( nav_width > container_width ) {
      container.classList.add('is-scrollable');
      container.querySelector('.local-nav-list').insertAdjacentHTML('beforeend', triggerHTML);
      this.observer(container);
    }
  }
  observer (container) {
    const observer = new IntersectionObserver(this.callback, {
      root: container,
      rootMargin: '0% 0%',
      threshold: 0
    });
    const triggerFirst = container.querySelector('.trigger-first');
    const triggerLast = container.querySelector('.trigger-last');
    observer.observe(triggerFirst);
    observer.observe(triggerLast);
  }

  callback (entries) {
    entries.forEach( entry => {
      if( entry.target.classList.contains('trigger-first') ){
        if( entry.isIntersecting ) {
          entry.target.closest('.local-nav-mask').classList.add('is-first-edge');
        }else{
          entry.target.closest('.local-nav-mask').classList.remove('is-first-edge');
        }
      }
      if( entry.target.classList.contains('trigger-last') ){
        if( entry.isIntersecting ) {
          entry.target.closest('.local-nav-mask').classList.add('is-last-edge');
        }
        else {
          entry.target.closest('.local-nav-mask').classList.remove('is-last-edge');
        }
      }
    });
  }
}